var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListenerLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 17,
    viewBox: "0 0 74 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#EDF4FF",
    d: "M70.772 15.5H.62c-.028 0-.108-.08-.12-.227L2.976.846l.007-.042V.762c0-.17.09-.262.12-.262h70.151c.028 0 .108.08.12.227l-2.475 14.427-.007.042v.042c0 .17-.09.262-.12.262z",
    transform: "translate(-662 -645) translate(352 608) translate(310 37) translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006DC9",
    d: "M3.456 1l-2.4 14h69.363l2.4-14H3.457m-.353-1h70.151c.343 0 .621.341.621.762l-2.483 14.476c0 .42-.278.762-.62.762H.62C.278 16 0 15.659 0 15.238L2.483.762c0-.42.278-.762.62-.762z",
    transform: "translate(-662 -645) translate(352 608) translate(310 37) translate(0 1)"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#006DC9",
    fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji",
    fontSize: 11,
    fontStyle: "italic",
    fontWeight: 700,
    transform: "translate(-662 -645) translate(352 608) translate(310 37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 16.555,
    y: 12.5
  }, "Listener"))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListenerLabel);
export default __webpack_public_path__ + "static/media/listener-label.c62a6d76aa15953dae83a268e66b61aa.svg";
export { ForwardRef as ReactComponent };